import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import Layout from './components/common/Layout';
import MaintenanceMode from './components/common/MaintenanceMode';
import Loading from './components/common/Loading';
import Home from './pages/Home';
import Tracks from './pages/Tracks';
import About from './pages/About';
import { isMaintenanceMode } from './services/api';
import './styles/variables.css';
import './styles/globals.css';
import './styles/animations.css';

const App = () => {
  const [loading, setLoading] = useState(true);
  const [maintenanceMode, setMaintenanceMode] = useState(false);

  useEffect(() => {
    const checkMaintenance = async () => {
      try {
        const isInMaintenance = await isMaintenanceMode();
        setMaintenanceMode(isInMaintenance);
      } catch (error) {
        console.error('Error checking maintenance mode:', error);
        setMaintenanceMode(false); // Default to false if check fails
      } finally {
        setLoading(false);
      }
    };

    checkMaintenance();
  }, []);

  if (loading) {
    return (
      <ThemeProvider>
        <Loading />
      </ThemeProvider>
    );
  }

  if (maintenanceMode) {
    return (
      <ThemeProvider>
        <MaintenanceMode />
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider>
      <Router>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/tracks" element={<Tracks />} />
            <Route path="/about" element={<About />} />
          </Routes>
        </Layout>
      </Router>
    </ThemeProvider>
  );
};

export default App;